"use client";
import { Breadcrumb } from "@/components";
import type { TopBannerProps } from "@/types/top-banner.types";

export default function TopBannerWide({ title, breadcrumb }: TopBannerProps) {
	return (
		<section
			className="
				spaced-between
				border-dividerSilent
				bg-layoutContainer
				relative
				flex
				h-[152px]
				items-center
				border-b
				px-[112px]
			"
		>
			<div className="grow pb-1">
				<Breadcrumb crumbs={breadcrumb} />
				<h1
					className="hmc-title-xl text-systemInfo"
					data-testid="top-banner-title"
				>
					{title}
				</h1>
			</div>
		</section>
	);
}
